"use client";
import { jsx as e, Fragment as l } from "react/jsx-runtime";
import { createSvgIcon as t } from "@mui/material/utils";
const o = t(
  /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(
    "path",
    {
      d: "M5.79 4.17016L16.55 10.0402L16.56 10.0502C17.29 10.4502 17.72 11.1802 17.72 12.0102C17.72 12.8402 17.29 13.5702 16.56 13.9702L5.78 19.8502C5.42 20.0502 5.03 20.1602 4.62 20.1602C4.21 20.1602 3.8 20.0502 3.43 19.8402C2.69 19.4102 2.25 18.6502 2.25 17.7902V6.22016C2.25 5.36016 2.69 4.60016 3.43 4.17016C4.17 3.74016 5.05 3.74016 5.79 4.17016ZM20.2891 5.00004C20.2891 4.61004 20.6091 4.29004 20.9991 4.29004C21.3891 4.29004 21.7091 4.61004 21.7091 5.00004V19C21.7091 19.39 21.3891 19.71 20.9991 19.71C20.6091 19.71 20.2891 19.39 20.2891 19V5.00004Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }),
  "KmxSkipNextFilled"
);
export {
  o as default
};
